export async function sleep(ts = 3000) {
    return new Promise((res) => {
        setTimeout(res, ts);
    }, []);
}
